// import TipService from '@/services/requests/tipService'
import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'

export default {
  methods: {
    getTips() {
      this.loadingTips = true
      var urlString = 'tips'
      if (!!this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.loadingTips = false
          this.tips = result.data.result
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingTips = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingTips: Store.getSet({ store: 'tips', prop: 'loadingTips' }),
    tips: Store.getSet({ store: 'tips', prop: 'tips' })
  },
  mounted() {
    if (!this.tips.length && this.$route.name !== 'audit') {
      this.getTips()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.tips = []
  }
}
